const rawBaseUrl = process.env.REACT_APP_DASHBOARD_API_BASE_URL
  || process.env.REACT_APP_API_BASE_URL
  || 'http://localhost:8000';

const normalizeBase = (url) => {
  if (!url) return '';
  return url.replace(/\/$/, '');
};

export const DASHBOARD_API_BASE_URL = normalizeBase(rawBaseUrl);

export const buildDashboardApiUrl = (path = '') => {
  if (!path) {
    return DASHBOARD_API_BASE_URL;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${DASHBOARD_API_BASE_URL}${normalizedPath}`;
};

